import { j as e } from "../../../../../../../jsx-runtime.BREq8dyb.js";
import { faTrashCan as x, faPlus as g } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as m } from "@fortawesome/react-fontawesome";
import { Stack as t, FormControl as c, FormLabel as j, Input as u, IconButton as h, FormHelperText as C, Button as w } from "@mui/joy";
import { memo as b, useEffect as y } from "react";
import { b as D, d as F, C as k } from "../../../../../../../react-hook-form.Du3weLRK.js";
import r from "../../../../DqDatasetSyncControlledInput/DqDatasetSyncControlledInput.js";
import O from "../../labels/ConfigurationLabel/ConfigurationLabel.js";
import A from "../../labels/CredentialsLabel/CredentialsLabel.js";
const S = b(() => {
  const {
    control: a
  } = D(), {
    fields: o,
    append: s,
    remove: d
  } = F({
    control: a,
    name: "adformDsp.segmentOwners"
  });
  return y(() => {
    o.length === 0 && s("");
  }, [s, o.length]), /* @__PURE__ */ e.jsxs(t, { children: [
    /* @__PURE__ */ e.jsx(O, {}),
    /* @__PURE__ */ e.jsx(r, { label: "Bucket name", name: "adformDsp.aws.targetConfig.bucket", placeholder: 'e.g. "data-providers"' }),
    /* @__PURE__ */ e.jsx(r, { label: "Region code", name: "adformDsp.aws.targetConfig.region", placeholder: 'e.g. "eu-central-2"' }),
    /* @__PURE__ */ e.jsx(r, { label: "Object name (Key)", name: "adformDsp.aws.targetConfig.objectKey", placeholder: 'e.g. "dt=20250101/my-file.csv"' }),
    /* @__PURE__ */ e.jsxs(c, { required: !0, children: [
      /* @__PURE__ */ e.jsx(j, { children: "Segment Owners" }),
      /* @__PURE__ */ e.jsxs(t, { children: [
        o.map((i, n) => /* @__PURE__ */ e.jsx(k, { control: a, name: `adformDsp.segmentOwners.${n}`, render: ({
          field: p,
          fieldState: f
        }) => {
          const {
            error: l
          } = f;
          return /* @__PURE__ */ e.jsxs(c, { error: !!l, required: !0, children: [
            /* @__PURE__ */ e.jsxs(t, { direction: "row", sx: {
              flex: 1
            }, children: [
              /* @__PURE__ */ e.jsx(u, { placeholder: `e.g. "KLAB00${n + 1}"`, ...p, sx: {
                flex: 1
              } }),
              o.length > 1 ? /* @__PURE__ */ e.jsx(h, { onClick: () => d(n), children: /* @__PURE__ */ e.jsx(m, { icon: x }) }) : null
            ] }),
            /* @__PURE__ */ e.jsx(C, { children: l?.message || "" })
          ] });
        } }, i.id)),
        /* @__PURE__ */ e.jsx(w, { onClick: () => s(""), startDecorator: /* @__PURE__ */ e.jsx(m, { icon: g }), children: "Add Segment Owner" })
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(A, {}),
    /* @__PURE__ */ e.jsx(r, { label: "Access key", name: "adformDsp.aws.credentials.accessKey", placeholder: 'e.g. "5JG8C6HNDPQF7W2X3Y1Z"', type: "masked" }),
    /* @__PURE__ */ e.jsx(r, { label: "Secret key", name: "adformDsp.aws.credentials.secretKey", placeholder: 'e.g. "F57yT3QaX2nD8jHr4KlP9cVs1W6zU0E2sY8hN4bM"', type: "masked" })
  ] });
});
S.displayName = "AdformFormControls";
export {
  S as default
};
//# sourceMappingURL=AdformFormControls.js.map
